<!--
 * @Description: 择样记录
 * @Author: zml
 * @Date: 2022-10-27 09:06:05
 * @LastEditors: zml
 * @LastEditTime: 2024-12-28 12:26:03
-->
<template>
  <div class="select-record" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="top">
      <div class="search" ref="searchBox">
        <el-form ref="ruleForm" :inline="true" :model="queryParam" class="demo-form-inline">
          <el-form-item label="厂商编号:" prop="ma_Nu">
            <el-input
              style="width:3.80rem"
              ref="ma_Nu"
              v-model="queryParam.ma_Nu"
              placeholder="请输入厂商编号"
              @keydown.enter.native="getManufacturerInfo"
              @blur="onBlur"
              @focus="maNuFocus"
            ></el-input>
            <el-button style="width:50px; border: none;" plain @click="showKeyboard('ma_Nu')">
              <i class="iconfont icon-jianpan" style="font-size:0.3rem"></i>
            </el-button>
          </el-form-item>
          <el-form-item label="厂商名称:" prop="ma_Na">
            <el-input style="width:3.80rem" v-model="queryParam.ma_Na" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="摊位号:" prop="booth_Nu">
            <el-input style="width:3.80rem" v-model="queryParam.booth_Nu" :disabled="true"></el-input>
          </el-form-item>

          <!-- <el-form-item label="样品货号:" prop="fa_No">
            <el-input style="width:2.5rem" v-model="queryParam.fa_No" placeholder="请输入样品货号" @keydown.enter.native="getManufacturerInfo"></el-input>
          </el-form-item>-->
          <!-- <el-form-item label="查询天数:" prop="days">
            <el-select style="width:1.5rem" v-model="queryParam.days" placeholder="天数">
              <el-option label="7天" :value="7"></el-option>
              <el-option label="14天" :value="14"></el-option>
              <el-option label="30天" :value="30"></el-option>
            </el-select>
          </el-form-item>-->
        </el-form>
        <div class="right-form">
          <el-form ref="ruleForm" :inline="true" :model="queryParam" class="demo-form-inline" style="margin-top: 15px;">
            <el-form-item label="请输入天数进行查询">
              <el-input-number v-model="days" :min="1" :max="90" @change="handleChange" :precision="0"></el-input-number>
              <span style="font-size: 20px;margin-left: 5px">天之内</span>
            </el-form-item>
            <el-form-item>
              <div class="daysOptions">
                <div @click="getdaysenTime(7)" :class="indexTime ==7 ? 'active':''">7天</div>
                <div @click="getdaysenTime(15)" :class="indexTime ==15 ? 'active':''">15天</div>
                <div @click="getdaysenTime(30)" :class="indexTime ==30 ? 'active':''">30天</div>
                <div @click="getdaysenTime(45)" :class="indexTime ==45 ? 'active':''">45天</div>
                <div @click="getdaysenTime(60)" :class="indexTime ==60 ? 'active':''">60天</div>
              </div>
            </el-form-item>
          </el-form>
          <div class="btns">
            <div class="suceess" @click="query">查询</div>
            <div class="cancel" @click="onReset">清空所有记录</div>
            <!-- <el-button type @click="query" style="height: 40px;">查询</el-button>
            <el-button type @click="onReset" style="height: 40px;">清空所有记录</el-button>-->
          </div>
        </div>
      </div>
      <div class="content" ref="tableDom" id="idDom">
        <el-table
          ref="pleTable"
          :height="tableHeight"
          :row-key="(row)=>{ return row.id}"
          @selection-change="handleSelectCodeForTicket"
          :data="tableData"
          style="width: 100%;"
        >
          <!-- <el-table-column align="center" type="selection" label="全选" :reserve-selection="true" width="80"></el-table-column> -->
          <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
          <el-table-column align="center" prop="fa_No" label="出厂货号"></el-table-column>
          <el-table-column align="center" prop="client_Nu" label="客户编号"></el-table-column>
          <el-table-column align="center" prop="client_Na" label="客户名称"></el-table-column>
          <el-table-column align="center" prop="ch_Pa" label="包装"></el-table-column>
          <el-table-column align="center" prop="happenDate" label="择样日期"></el-table-column>
          <el-table-column align="center" prop="isReplenishinfo" label="补样情况"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="footer" ref="footer">
      <div class="btn-box">
        <div class="btn-left" style="width: 20%;">
          <!-- <el-button class="btn1" style="margin:0 0.20rem 0 0" @click="selectAll">全选({{ selectionRows.length }})</el-button>
          <el-button class="btn2" style="margin:0 0.20rem 0 0" @click="selectInvert">反选</el-button>
          <el-button class="btn3" style="margin:0 0.10rem 0 0" @click="selectCancel">取消选择</el-button>-->
        </div>
        <div class="technical-support">技术支持：宏升云科技</div>
        <div class="btn-right">
          <span class="page">共{{totalRows}}条记录 第{{queryParam.pageNo }}/{{totalPage}}页</span>
          <el-button class="btn4" style="margin:0 0 0 0.20rem" @click="pageUp">
            <i class="el-icon-arrow-left"></i>上一页
          </el-button>
          <el-button class="btn5" style="margin:0 0 0 0.20rem" @click="pageDown ">
            下一页
            <i class="el-icon-arrow-right"></i>
          </el-button>
        </div>
      </div>
      <el-dialog
        center
        width="25%"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        :visible.sync="visible"
        :before-close="handleClose"
      >
        <div>
          <div>
            <div style="text-align: start;color: black;font-size: 18px;margin-bottom: 10px;">厂商密码</div>
            <div style="display: flex;align-items: center;">
              <el-input v-model="mu_password" ref="mu_password" placeholder="请输入厂商密码" @focus="mupassword" @blur="onBlurPass"></el-input>
              <i
                class="iconfont icon-jianpan"
                style="font-size:0.3rem;color: black;margin: 5px;cursor: pointer;"
                @click="showKeyboard('mu_password')"
              ></i>
            </div>
          </div>
          <div class="dialogBtns">
            <div class="cancel" @click="visible = false">取消</div>
            <div class="suceess" @click="submitpassword">确认</div>
          </div>
        </div>
      </el-dialog>
      <simple-keyboard
        @onChange="onChangeKeyboard"
        @onKeyPress="onKeyPress"
        @close="closeKeyboard"
        :input="input"
        v-show="showVirtual"
        :fiedTop="fiedTop"
        :zindex="zindex"
      ></simple-keyboard>
    </div>
  </div>
</template>
<script>
import { QuoteHistoryQueryPage, GetManufacturerInfo, decryptingQRcode, getExhibitionCode, verificationPassWord, decryptingHSQRcode } from '@/api/home'
import sortNum from './sortNum.vue'
import { mapState } from 'vuex'
import simpleKeyboard from '@/components/simpleKeyboard.vue'

import moment from 'moment'
var timer = null
export default {
  name: 'homePage',
  components: {
    sortNum,
    simpleKeyboard
  },

  data() {
    return {
      indexTime: 7,
      fiedTop: '1.1rem',
      zindex: 99,
      mu_queryparamts: "",
      mu_inpustStatus: false,
      mu_password: "",
      visible: false,
      input: '',
      // 表格高度
      tableHeight: 'calc(100vh - 2.5rem)',
      // 表格数据
      tableData: [],
      // 选中的数据id集
      selectionIds: [],
      // 选中的数据集
      selectionRows: [],
      // 加载
      fullscreenLoading: false,
      // 查询参数
      queryParam: {
        pageNo: 1,
        pageSize: 50,
        sortField: '',
        sortOrder: '',
        keywords: '',
        ma_Nu: '',
        ma_Na: '',
        fa_No: '',
        startTime: this.getDateAfterDays(7),
        endTime: this.getDateAfterDays(0)
      },
      days: 7,
      time: 60,
      showTime: false,
      // 当前页数
      totalPage: 0,
      // 当前数据条数
      totalRows: 0,
      isFocus: false,
      isFocusPassword: false,
      exhibitionCode: '', // 展厅识别码
      showVirtual: false,
      ma_Nuquery: ""
    }
  },
  computed: {
    ...mapState('tenant', ['tenantInfo'])
  },
  created() {
    this.initData()
  },
  mounted() {
    this.$refs.ma_Nu.focus()

    // 窗口变化
    window.addEventListener('resize', () => {
      this.tableHeight = document.body.clientHeight - this.$refs.searchBox.clientHeight - this.$refs.tableTitle.clientHeight - this.$refs.footer.clientHeight
    })

    window.addEventListener('click', () => {
      this.time = 60
    })
  },
  destroyed() {
    window.removeEventListener('resize', () => { })
    window.removeEventListener('click', () => { })
  },
  watch: {
    'queryParam': {
      handler() {
        if (this.queryParam.ma_Nu != this.mu_queryparamts) {
          this.mu_inpustStatus = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleClose() {
      this.showVirtual = false;
      this.visible = false
      this.mu_password = ''
    },

    //获取当前日期函数
    getNowFormatDate() {
      let date = new Date()
      let year = date.getFullYear() //获取完整的年份(4位)
      let month = date.getMonth() + 1 //获取当前月份(0-11,0代表1月)
      let strDate = date.getDate() // 获取当前日(1-31)
      if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0
      return `${year}-${month}-${strDate}`
    },
    getDateAfterDays(days) {
      // 获取当前日期
      const currentDate = new Date();
      // 设置天数（注意：当前日期的天数不会被重置，除非超过月份的天数）
      currentDate.setDate(currentDate.getDate() - days);

      // 格式化日期为YYYY-MM-DD格式
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1
      const day = String(currentDate.getDate()).padStart(2, '0');
      // 拼接成最终日期字符串
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },
    handleChange(value) {
      this.queryParam.startTime = this.getDateAfterDays(value);
    },
    getdaysenTime(dasy) {
      this.queryParam.startTime = this.getDateAfterDays(dasy);
      this.days = dasy;
      this.indexTime = dasy
    },
    initData() {
      getExhibitionCode().then(res => {
        if (res.success) {
          this.exhibitionCode = res.data || ''
        } else {
          this.$message.error(JSON.stringify(res.message))
        }
      })
    },
    query() {
      if (this.mu_inpustStatus) {
        this.queryData()
        return
      }
      if (!this.queryParam.ma_Nu) {
        this.$message.warning('请先输入厂商编号或摊位号')
        this.$refs.ma_Nu.focus()
        return
      }
      this.tableData = []
      this.selectionIds = []
      this.selectionRows = []
      this.queryParam.pageNo = 1
      this.getManufacturerInfo();
    },
    // 获取厂商择样记录表数据
    queryData() {
      this.fullscreenLoading = true
      QuoteHistoryQueryPage(this.queryParam).then(res => {
        if (res.success) {
          this.totalPage = res.data.totalPage
          this.totalRows = res.data.totalRows
          this.tableData = res.data.rows || []
          this.tableData.forEach(item => {
            item.happenDate = this.filterDate(item.happenDate)
          })
          const _this = this
          if (timer) {
            this.time = 60
            clearInterval(timer)
          }
          this.showTime = true
          timer = setInterval(() => {
            _this.time--
            if (_this.time <= 0) {
              _this.onReset()
              _this.time = 60
              _this.showTime = false
              clearInterval(timer)
            }
          }, 1000)
          this.$refs.ma_Nu.focus()
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.$message.error(err)
      }).finally(() => {
        this.fullscreenLoading = false
      })
    },
    showKeyboard(type) {
      switch (type) {
        case 'ma_Nu':
          this.fiedTop = '1.1rem';
          this.zindex = 99
          this.showVirtual = !this.showVirtual
          this.$refs.ma_Nu.focus()
          break
        case 'mu_password':
          this.fiedTop = '2.8rem';
          this.zindex = 9999999999
          this.showVirtual = !this.showVirtual
          this.$refs.mu_password.focus()
          break
      }
    },
    // 获取厂商名称
    async getManufacturerInfo() {
      if (!this.queryParam.ma_Nu) {
        this.$message.warning('请先输入厂商编号')
        this.$refs.ma_Nu.focus()
        return
      }
      // 大于20个字符

      if (this.queryParam.ma_Nu.length > 20 && this.queryParam.ma_Nu.indexOf('hsrj') === -1) {
        const result = await decryptingQRcode({ code: this.queryParam.ma_Nu })
        if (result.success) {
          const strArr = result.data.split(';')
          // 判断展厅识别码
          if (this.exhibitionCode !== strArr[5]) {
            this.queryParam.ma_Nu = ''
            this.$message.error('该二维码不是当前展厅，请出示当前展厅的厂商二维码')
            this.$refs.ma_Nu.focus()
            return
          }

          // 判断二维码有效期
          const qrCodeTime = moment(strArr[1])
          const systemTime = moment()
          if (qrCodeTime.isBefore(systemTime)) {
            this.queryParam.ma_Nu = ''
            this.$message.error('二维码已失效，请出示有效的二维码')
            this.$refs.ma_Nu.focus()
            return
          }

          this.queryParam.ma_Nu = strArr[3]
        } else {
          this.queryParam.ma_Nu = ''
          this.$message.error(JSON.stringify(result.message))
          this.$refs.input.focus()
          return
        }
      }

      if (this.queryParam.ma_Nu.indexOf('hsrj') > -1) {
        const code = this.queryParam.ma_Nu.substring(this.queryParam.ma_Nu.indexOf('hsrj') + 4)
        const result = await decryptingHSQRcode({ code: code })
        if (result.success) {
          const strArr = result.data.split(',')
          // 判断展厅识别码
          if (this.tenantInfo.id != strArr[1]) {
            this.queryParam.ma_Nu = ''
            this.$message.error('该二维码不是当前展厅，请出示当前展厅的厂商二维码')
            this.$refs.ma_Nu.focus()
            return
          }

          // 判断二维码有效期
          const qrCodeTime = moment(strArr[2])
          const systemTime = moment()
          if (qrCodeTime.isBefore(systemTime)) {
            this.queryParam.ma_Nu = ''
            this.$message.error('二维码已失效，请出示有效的二维码')
            this.$refs.ma_Nu.focus()
            return
          }

          this.queryParam.ma_Nu = strArr[0]
        } else {
          this.queryParam.ma_Nu = ''
          this.$message.error(JSON.stringify(result.message))
          this.$refs.input.focus()
          return
        }
      }

      if (this.queryParam.ma_Nu) {
        GetManufacturerInfo({ ma_Nu: this.queryParam.ma_Nu }).then(res => {
          if (res.success) {
            if (res.data) {
              // 打开厂商密码
              this.visible = true
              this.queryParam.ma_Nu = res.data.ma_Nu
              this.mu_queryparamts = res.data.ma_Nu
              this.queryParam.ma_Na = res.data.ma_Na
              this.queryParam.booth_Nu = res.data.booth_Nu
            } else {
              this.$message.error('不存在的厂商信息，请输入正确的厂商编号')
              this.queryParam.ma_Na = ''
              this.$refs.input.focus()
            }
          } else {
            this.queryParam.ma_Na = ''
            this.$message.error(JSON.stringify(res.message))
          }
        })
      } else {
        this.queryParam.ma_Na = ''
      }
    },
    submitpassword() {
      verificationPassWord({
        ma_Nu: this.queryParam.ma_Nu,
        password: this.mu_password
      }).then(res => {
        if (res.data) {
          this.queryData();
          this.visible = false;
          this.mu_password = ''
          this.mu_inpustStatus = res.data
          this.showVirtual = false;
          this.ma_Nuquery = ''
        } else {
          this.$message.error('厂商密码输入错误，请重新输入')
        }
      });
    },
    onChangeKeyboard(input) {
      if (this.focusField == 'mu_password') {
        this.mu_password = input
      } else {
        this.queryParam[this.focusField] = input
      }
      console.log(this.focusField);
      setTimeout(() => {
        this.$refs[this.focusField].focus()
      }, 10);
    },
    onKeyPress(button) {
      if (this.focusField == 'mu_password') {
        if (button === '{enter}') {
          this.submitpassword();
        }
      } else {
        if (button === '{enter}') {
          this.getManufacturerInfo()
        }
      }
    },
    // 关闭虚拟键盘
    closeKeyboard() {
      this.showVirtual = false
      this.$refs[this.focusField].focus()
    },
    // 失焦点
    onBlur() {
      if (!this.isFocus) {
        this.isFocus = true
        const _this = this
        setTimeout(() => {
          _this.isFocus = false
          _this.$refs.ma_Nu.focus()
        }, 10000)
      }
    },
    // 失焦点
    onBlurPass() {
      if (!this.isFocusPassword) {
        this.isFocusPassword = true
        const _this = this
        setTimeout(() => {
          _this.isFocusPassword = false
          _this.$refs.mu_password.focus()
        }, 10)
      }
    },
    // 重置
    onReset() {
      if (timer) {
        this.showTime = false
        this.time = 60
        clearInterval(timer)
      }
      this.mu_inpustStatus = false;
      this.$refs.ruleForm.resetFields()
      this.$refs.ma_Nu.focus()
      this.tableData = []
      this.selectionIds = []
      this.selectionRows = []
      this.queryParam.pageNo = 1
      this.queryParam.ma_Nu = ''
      this.queryParam.ma_Na = ''
      this.queryParam.booth_Nu = ''
      this.indexTime = 7
      this.queryParam.startTime = this.getDateAfterDays(7)
      this.days = 7
    },
    // 过滤时间
    filterDate(dateTime) {
      let date = new Date(dateTime)
      let year = date.getFullYear()
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      let day = date.getDate()
      return year + '-' + month + '-' + day
    },
    // 厂商编号获取焦点
    maNuFocus() {
      this.input = this.queryParam.ma_Nu
      this.focusField = 'ma_Nu'
    },
    mupassword() {
      this.input = this.mu_password
      this.focusField = 'mu_password'
    },
    // 上一页
    pageUp() {
      if (!this.mu_inpustStatus) {
        this.tableData = []
        this.days = 7
        this.indexTime = 7
        this.queryParam.ma_Na = '';
        this.queryParam.booth_Nu = ''
        this.queryParam.startTime = this.getDateAfterDays(7);
        this.getManufacturerInfo();
        return
      }
      if (this.queryParam.pageNo !== 1) {
        this.queryParam.pageNo -= 1
        this.queryData()
      }
    },
    // 下一页
    pageDown() {
      if (!this.mu_inpustStatus) {
        this.tableData = []
        this.days = 7
        this.indexTime = 7
        this.queryParam.ma_Na = '';
        this.queryParam.startTime = this.getDateAfterDays(7);
        this.queryParam.booth_Nu = ''
        this.getManufacturerInfo();
        return
      }
      if (this.queryParam.pageNo !== this.totalPage && this.totalPage != 0) {
        this.queryParam.pageNo += 1
        this.queryData()
      }
    },
    // 全选
    selectAll() {
      this.$refs.pleTable.toggleAllSelection()
    },
    // 反选
    selectInvert() {
      if (this.tableData.length > 0) {
        this.tableData.forEach(row => {
          this.$refs.pleTable.toggleRowSelection(row)
        })
      }
    },
    // 取消选中
    selectCancel() {
      this.$refs.pleTable.clearSelection()
    },

    // 选中的数据
    handleSelectCodeForTicket(val) {
      this.selectionIds = []
      this.selectionRows = val
      val.forEach(v => {
        this.selectionIds.push(v.id)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.select-record {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  font-family: MicrosoftYaHei;

  .top {
    flex: 1;
    display: flex;
    flex-direction: column;
    .search {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      height: 1.1rem;
      padding: 0.3rem 0.2rem 0.2rem 0.2rem;

      .right-form {
        display: flex;
        width: 100%;
      }
      .btns {
        display: flex;
        padding-top: 25px;
        > div {
          height: 0.4rem;
          border-radius: 5px;
          line-height: 0.4rem;
          text-align: center;
          border: 1px solid rgb(235, 231, 231);
          cursor: pointer;
          font-size: 0.17rem;
        }
        .suceess {
          width: 1rem;
          margin-right: 20px;
          color: black;
          background-color: #1890ff;
          color: white;
        }
        .cancel {
          width: 2rem;
          color: #fff;
          margin-right: 10px;
          background-color: #f56c6c;
        }
      }
      .el-form {
        display: flex;
        width: 100%;
      }

      :deep .el-form-item {
        display: flex;
        align-items: center;
        margin: 0 0.24rem 0 0;

        .el-form-item__label {
          font-size: 0.24rem !important;
          color: #222222;
        }

        .el-input__inner {
          font-size: 0.24rem !important;
          height: 0.5rem !important;
          line-height: 0.5rem !important;
          color: #8a8a8a;
        }
        button {
          height: 0.5rem !important;
          font-size: 0.24rem !important;
          line-height: 0.5rem;
          padding: 0;
          width: 1.1rem;
          color: #222222;
        }
        &:last-child {
          margin: 0 !important;
        }
      }
    }

    .content {
      flex: 1;
      padding: 0 0.2rem;

      .table-title {
        position: relative;
        font-size: 0.3rem;
        height: 0.55rem;
        text-align: center;
        color: #1b1b1d;
        font-family: MicrosoftYaHei-Bold;
        font-weight: bold;
      }

      .time-box {
        position: absolute;
        top: 0;
        right: 0;
        height: 0.55rem;
        line-height: 0.55rem;
        font-size: 0.15rem;
        color: #f00;
      }
      :deep .el-table {
        border: 0.01rem solid #eee;
        color: #222222;
        font-size: 0.24rem;

        .cell {
          line-height: 0.4rem !important;
        }
        tr {
          background-color: #eff6fe;
          height: 0.7rem;
        }

        th.el-table__cell {
          background: #1890ff;
          color: #ffffff;
          border-bottom: 1px solid #fff;
        }
        .el-checkbox__inner {
          width: 0.24rem;
          height: 0.24rem;
          &::after {
            height: 0.16rem;
            left: 0.07rem;
            top: 0;
            width: 0.08rem;
          }

          &::before {
            top: 0.11rem;
          }
        }
        .el-table__empty-block {
          background-color: #eff6fe;
        }
      }
    }
  }

  .footer {
    height: 1.4rem;
    padding: 0.1rem 0.4rem 0;
    box-sizing: border-box;

    button {
      height: 0.5rem;
      line-height: 0.5rem;
      padding: 0;
      font-size: 0.2rem;
      min-width: 1.2rem;
      color: #fff;
    }
    .btn-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.6rem;
      .btn1 {
        background-color: #5c82f7;
      }
      .btn2 {
        background-color: #58a6f8;
      }
      .btn3 {
        background-color: #e67480;
      }
      .btn4 {
        background-color: #10bda8;
      }
      .btn5 {
        background-color: #10bda8;
      }
      .btn6 {
        background-color: #1890ff;
      }
    }
    .technical-support {
      height: 0.7rem;
      text-align: center;
      line-height: 0.7rem;
      color: #266989;
      font-size: 0.2rem;
    }

    .btn-right {
      .page {
        font-size: 0.2rem;
      }
    }
  }
}
::v-deep .el-input-number__decrease {
  height: 96%;
}
::v-deep .el-input-number__increase {
  height: 96%;
}

::v-deep .el-input-number__decrease .el-icon-minus {
  font-size: 0.2rem;
  font-weight: 500;
  line-height: 0.5rem;
}

::v-deep .el-input-number__increase .el-icon-plus {
  font-size: 0.2rem;
  font-weight: 500;
  line-height: 0.5rem;
}

.daysOptions {
  display: flex;
  div {
    width: 1rem;
    height: 0.4rem;
    margin-right: 15px;
    border-radius: 5px;
    font-weight: 500;
    font-size: 0.18rem;
    border: 1px solid rgb(221, 220, 220);
    text-align: center;
    cursor: pointer;
  }
  .active {
    background-color: #1890ff;
    color: #fff;
  }
}
.dialogBtns {
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  > div {
    width: 1rem;
    height: 35px;
    border-radius: 5px;
    line-height: 35px;
    border: 1px solid rgb(235, 231, 231);
    cursor: pointer;
    font-size: 0.17rem;
  }
  .suceess {
    color: black;
    background-color: #1890ff;
    color: white;
  }
  .cancel {
    color: black;
    margin-right: 10px;
    background-color: rgb(228, 226, 226);
  }
}

// 滚动条的宽度
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 40px;
  height: 40px;
  margin: 0;
  padding: 0;
}
// 滚动条的滑块
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #1890ff;
}
::v-deep .el-table__body-wrapper {
  background: #eff6fe;
}
</style>